import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';

import { CerrarSesion } from '../utils/componentes-utiles/CerrarSesion';
import InstallPWA from '../utils/InstallPWA';
import { Grid } from '@mui/system';

export const Header = ({ setOpenDrawer, openDrawer, logoCliente }) => {
	const [tokenusu, setTokenUsu] = useState('');
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const cargarNombre = () => {
			setTokenUsu(localStorage.getItem('DesRepresentante'));
		};

		cargarNombre();
		window.addEventListener('penya-auth-changed', cargarNombre);

		return () => {
			window.removeEventListener('penya-auth-changed', cargarNombre);
		};
	}, [location]);

	return (
		<Box className="header">
			{tokenusu && (
				<Grid
					container
					direction="row"
					size={{ xs: 12 }}
					sx={{
						justifyContent: "space-between",
						alignItems: "center",
					}}
				>
					<Grid
						container
						direction="row"
						size={{ xs: 3 }}
						sx={{
							justifyContent: "start",
							alignItems: "center",
						}}
					>
						<IconButton
							edge="start"
							color="inherit"
							aria-label="menu"
							className="app-header-menu-button"
							onClick={() => setOpenDrawer(!openDrawer)}
						>
							<MenuIcon />
						</IconButton>

						<AccountCircleIcon className="app-header-user-icon" />
						<Typography variant="body1" className="app-header-user-name">
							{tokenusu}
						</Typography>
					</Grid>

					<Grid
						container
						direction="row"
						size={{ xs: 5, sm: 4 }}
						sx={{
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Grid
							container
							size={{ xs: 5.5, sm: 3.25, md: 2.25, lg: 1.25 }} sx={{
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							{logoCliente ? (
								<img style={{ maxWidth: '100%', minWidth: '100%' }} src={logoCliente} alt="Logo" className="pointer" onClick={() => navigate('/')} />
							) : (
								<IconButton className="header-home-button" color="primary" onClick={() => navigate('/')} aria-label="Inici">
									<HomeIcon />
								</IconButton>
							)}
						</Grid>

					</Grid>

					<Grid
						container
						direction="row"
						size={{ xs: 3 }}
						spacing={1}
						sx={{
							justifyContent: "end",
							alignItems: "center",
						}}
					>
						{/* <InstallPWA /> */}
						<CerrarSesion />
					</Grid>




				</Grid>
			)}
		</Box>
	);
};
